import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import type { ExecutiveCompensationData } from '@shared/types';
import api from '../../../../api.js';

interface ExecutivePayState {
  data: ExecutiveCompensationData | null;
  loading: boolean;
  error: string | null;
  selectedDdlPeriodData: [];
}

const initialState: ExecutivePayState = {
  data: null,
  loading: false,
  error: null,
  selectedDdlPeriodData: [],
};

export const GetCompanyCompensationExecutivePayData = async (companyId: string) => {
  const response = await api.get(`/api/v3/executive-compensation/${companyId}`);
  return response.data;
};

export const fetchExecutiveCompensation = createAsyncThunk('executiveCompensation/fetch', async (companyId: string) => {
  return GetCompanyCompensationExecutivePayData(companyId);
});

const ExecutiveCompensationSlice = createSlice({
  name: 'executiveCompensation',
  initialState,
  reducers: {
    resetExecutiveCompensation: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExecutiveCompensation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExecutiveCompensation.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data ?? null;
        state.error = null;
      })
      .addCase(fetchExecutiveCompensation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to load executive compensation data';
      });
  },
});

export const { resetExecutiveCompensation } = ExecutiveCompensationSlice.actions;

export default ExecutiveCompensationSlice.reducer;
